import { SelectOptionType } from "../models/GlobalModels";

export const Constants = {
  APP_NAME: "Kshema CCE",

  // IS_USER_LOGED_IN: 'isUserLogedIn',
  AUTHENTICATION_DATUM: 'authenticationDatum',
  // USER_MOBILE_NUMBER: 'userMobileNumber',
};

export const DEFAULT_OPTION: SelectOptionType = { label: "Select", value: null };

export const SIDE_MENU_STATUS = {
  OPEN: 1,
  CLOSE: 2,
  OPPOSITE: 3,
};

export const LIST_VIEW_ITEM = {
  LIST_ITEMS: "list-items",
  VIEW_ITEM: "view-item",
};

export const STORAGE_KEY = {
  AUTH_DATA: "chm-app-auth",
  ITUS: "chm-app-itus",
  SSOT: "fa-sso-token",
};

export const API_RESPONSE_CODE = {
  FAIL: "1",
  SUCCESS: "0",
};

export const LOGIN_STATUS = {
  INITIATED: "initiated",
  AUTHENTICATED: "authenticated",
  NO_AUTHENTICATED: "no-authenticated",
};

export const ICV_STATUS = {
  ASSIGNED: 1,
  COMPLETED: 2,
  QC_PENDING: 3,
  QC_IN_PROGRESS: 4,
  REASSIGNED: 5,
  ON_HOLD:6
}

export const CROP_SOWN_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
]

export const IMAGE_QUALITY_OPTIONS = [
  { value: 'acceptable', label: 'Acceptable' },
  { value: 'nonAcceptable', label: 'Non Acceptable' }
]
export const ON_HOLD_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
]
export const ASSIGN_QC_ACTIONS = {
  ASSIGN: 1,
  REASSIGN: 2
}

export const PAGINATION_OPTIONS = {
  ICV_ACTIVITIES: ['250', '500', '1000', '2500'],
  COMPLETED_ICV: ['250', '500', '1000', '2500'],
  DEFAULT: ['25', '50', '100']
};